import type { DropStepClient } from 'types/api/step';

/**
 * For every step that has `time`, `hasApplianceControls` but no `usedAppliance`
 * we create fake "Local timer" appliance that will set up countdown and alarm
 */
export const shouldStepUseLocalTimer = (step: DropStepClient): boolean =>
  step.hasApplianceControls && !step.usedAppliance?.uri && !!step.time;
